var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],ref:"wrapper",staticClass:"wrapper"},[_c('ECharts',{ref:"chart",staticClass:"chart",attrs:{"options":{},"autoresize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }